import React, { Component} from 'react';
import { connect } from 'react-redux';
import {submitSearchRecord, recordSearchFormReset, recordSearchFormChange, submitSearchAllRecord, recordsAddModalOpen} from '../../actions/recordsActions';

import { Form, Icon, Input, Button, Row, Col, Divider, Tooltip } from 'antd';
import RecordAddFormModal from './RecordAddFormModal';
const FormItem = Form.Item;

class RecordSearchForm extends Component{
    showCreateButton(){
        if(this.props.records.length === 0)
            return false
            
        return !this.props.records.every((item)=>item.coincidence !=100)
    }

    validation(updatedSubmission){
        updatedSubmission['validation']['serial_number'] = '';
        updatedSubmission['validation']['hid'] = '';

        if(updatedSubmission['serial_number'].length > 0 && updatedSubmission['serial_number'].length < 5 
            || updatedSubmission['serial_number'].length > 5 )
            updatedSubmission['validation']['serial_number'] = 'должно быть 5 цифр';


        if(updatedSubmission['hid'].length > 0 && !/^([0-9A-Z-]{2}[-]{1}){16,}$/.test(updatedSubmission['hid']+'-'))
            updatedSubmission['validation']['hid'] = 'не похоже на HID';

        return updatedSubmission;
    }

    updateSubmission(event){
        let updatedSubmission = Object.assign({}, this.props.record_search_form);

        updatedSubmission['serial_number'] = updatedSubmission['serial_number'].replace(/\D/ig, '');

        updatedSubmission[event.target.id] = event.target.value;
        this.props.recordSearchFormChange(this.validation(updatedSubmission));
    }

    submitSubmission(type){
        switch(type){
            case 'all':
                this.props.submitSearchAllRecord();
                break;
            case 'byConfig':
                this.props.submitSearchRecord(Object.assign({}, this.props.record_search_form, {search_type:'by_config'}));
                break;
            default:
                this.props.submitSearchRecord(Object.assign({}, this.props.record_search_form, {search_type:'by_hid_serial'})); 
                break;
        }
    }

    hasErrors(){
        if(this.props.record_search_form.serial_number === '' && this.props.record_search_form.hid === '')
            return true;
    }

    render(){
        return(
            <Row>

                <Col>
                    <Form layout="inline">
                        <FormItem 
                            validateStatus={this.props.record_search_form.validation.hid.length ? "warning" : "success"}
                            help={this.props.record_search_form.validation.hid}
                        >
                            <Input style={{width:'400px'}} prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_search_form.hid} onChange={this.updateSubmission.bind(this)} id="hid" type="text" placeholder= "HID: XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX" />
                        </FormItem>
                        <FormItem
                            validateStatus={this.props.record_search_form.validation.serial_number.length ? "warning" : "success"}
                            help={this.props.record_search_form.validation.serial_number}
                        >
                            <Input style={{width:'200px'}} prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_search_form.serial_number} onChange={this.updateSubmission.bind(this)} id="serial_number" type="text" placeholder="SERIAL NUMBER: 00000" />
                        </FormItem>
                        <FormItem>
                            
                            <Button icon="search"  disabled={this.hasErrors()} type="primary" htmlType="submit" onClick={this.submitSubmission.bind(this)}>
                                поиск по HID
                            </Button>

                        </FormItem>
                        <FormItem>
                            <Tooltip placement="top" title="декодируется HID и поиск дает записи, в которых есть все или часть искомой конфигурации">
                                <Button icon="search"  disabled={this.hasErrors() || this.props.record_search_form.hid === ''} type="primary" htmlType="submit" onClick={this.submitSubmission.bind(this, 'byConfig')}>
                                    поиск по конфигурации
                                </Button>
                            </Tooltip>
                        </FormItem>
                        <FormItem>
                            <Button icon="search"  type="primary" htmlType="submit" onClick={this.submitSubmission.bind(this, 'all')}>
                                показать все записи
                            </Button>
                        </FormItem>
                        <FormItem>
                            <Button 
                                type="primary" 
                                disabled={this.showCreateButton()} 
                                icon="plus" 
                                type="dashed"
                                onClick={this.props.recordsAddModalOpen.bind(this, { hidden_data:false })}
                            >
                                создать новую запись
                            </Button>
                        </FormItem>
                    </Form>
                </Col>

            </Row>
        )
    }
}

const mapStateToProps = state => ({
    record_search_form: state.records.record_search_form,
    records: state.records.records
})

const mapDispatchToProps = dispatch => ({
    submitSearchRecord: payload => dispatch(submitSearchRecord(payload)),
    submitSearchAllRecord: payload => dispatch(submitSearchAllRecord(payload)),
    recordSearchFormReset: payload => dispatch(recordSearchFormReset()),
    recordSearchFormChange: payload => dispatch(recordSearchFormChange(payload)),
    recordsAddModalOpen: payload => dispatch(recordsAddModalOpen(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordSearchForm);


// WEBPACK FOOTER //
// ./src/components/containers/RecordSearchForm.js